export const FIREHOUSE_INSIDERS_PROGRAM_NAME = 'Firehouse Subs Insiders';

export const FIREHOUSE_INSIDERS_INFO_URL = '/firehouse-subs-insiders?source=my-account';

export const FIREHOUSE_INSIDERS_ARIA_LABEL = `I want to join ${FIREHOUSE_INSIDERS_PROGRAM_NAME} and consent to receiving occasional invites to surveys or focus groups via email.`;
